<template>
    <div class="carq-data">
      <div class="carq-display-flex carq-autos-dropdown" v-show="edited" @mouseleave="mouseLeave">
<!--        <select class='selectpicker' data-style='btn-select btn-primary' data-mobile="true" v-model="ap" @change="updateAP">-->
        <select class='selectpicker' data-style='btn-select btn-primary' v-model="ap" @change="updateAP">
          <option v-for="el in autoOps.all" :value="el[0]">{{el[1]}}</option>
        </select>
      </div>
      <div class="carq-display-flex" v-show="!edited">
        <span class="carq-font-size-14 js-carq-autos-add-value" v-if="ap == 0 || ap.length == 0" @mouseover="editAP">
          Dodaj
          <i class="fa fa-edit text-primary"></i>
        </span>
        <span class="carq-font-size-14 carq-text-bold js-carq-autos-add-value" v-if="ap > 0 || ap.length > 0" @mouseover="editAP">
          {{ getCurrent() }} <i class="fa fa-edit text-primary"></i>
        </span>
      </div>
    </div>
</template>

<script>

  export default {
    name: "carq_select",
    data: function () {
      return {
        edited: false,
        autoOps: []
      }
    },

    props: ['autoprop', 'autooptions'],

    components: {
    },

    computed: {
      ap: {
        get: function() {
          return this.$store.state.auto[this.autoprop];
        },
        set: function(value) {
          this.$store.commit('updateAuto', {obj: this.autoprop, value: value});
        }

      },
    },

    created: function () {
      this.autoOps = JSON.parse(this.autooptions);
      this.ap = this.autoOps.current;
      this.$store.commit('updateChanged', false);
    },

    mounted(){
      const el=$(this.$el).find('.selectpicker');
      if(el.size() > 0) {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
          el.selectpicker('mobile');
        }
      }
    },

    updated() {
      const el=$(this.$el).find('.selectpicker');
      if(el.size() > 0){
        el.selectpicker('show');
        el.selectpicker('val',this.ap);
      }
    },

    methods: {
      getCurrent: function(){
        let tt = '';
        const all = this.autoOps.all;
        const current = this.ap;

        for(let el of all){
          if( el[0] === current ){
            tt = el[1]
          }
        }

        return tt;
      },

      editAP: function(ev){
        let el = ev.target.parentNode.parentNode;
        this.edited = true;
      },

      updateAP: function(ev) {
        const el = ev.target;
        // $(el).selectpicker('destroy');
        this.edited = false;
      },

      mouseLeave: function(ev){
        const el = ev.target;
        // $(el).selectpicker('destroy');
        this.edited = false
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>